$(function(){
	//top the top
	$('.tothetop').on('click',function(e){
		e.preventDefault;
		$("body").animate({ scrollTop: 0 });
    });

    $(window).on('load', function () {
        var ihasssedrkosh = $('.initscroll, .bbp-template-notice.error');
        if (ihasssedrkosh.length) {
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: ihasssedrkosh.offset().top
                }, 1000);
            }, 100);
        }
    });
});


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/scroll/init.js
 **/